var Typography_module_default = {
	"font-body-xs-regular": "_font-body-xs-regular_6v6n8_12",
	"font-body-xs-semibold": "_font-body-xs-semibold_6v6n8_17",
	"font-body-xs-medium": "_font-body-xs-medium_6v6n8_22",
	"font-body-sm-regular": "_font-body-sm-regular_6v6n8_31",
	"font-body-sm-semibold": "_font-body-sm-semibold_6v6n8_36",
	"font-body-sm-medium": "_font-body-sm-medium_6v6n8_41",
	"font-body-md-regular": "_font-body-md-regular_6v6n8_50",
	"font-body-md-semibold": "_font-body-md-semibold_6v6n8_55",
	"font-body-md-medium": "_font-body-md-medium_6v6n8_60",
	"font-body-lg-regular": "_font-body-lg-regular_6v6n8_69",
	"font-body-lg-semibold": "_font-body-lg-semibold_6v6n8_74",
	"font-body-lg-medium": "_font-body-lg-medium_6v6n8_79",
	"font-heading-sm-regular": "_font-heading-sm-regular_6v6n8_88",
	"font-heading-sm-semibold": "_font-heading-sm-semibold_6v6n8_93",
	"font-heading-sm-medium": "_font-heading-sm-medium_6v6n8_98",
	"font-heading-md-regular": "_font-heading-md-regular_6v6n8_107",
	"font-heading-md-semibold": "_font-heading-md-semibold_6v6n8_112",
	"font-heading-lg-regular": "_font-heading-lg-regular_6v6n8_121",
	"font-heading-lg-semibold": "_font-heading-lg-semibold_6v6n8_126",
	"font-heading-xl-regular": "_font-heading-xl-regular_6v6n8_135",
	"font-heading-xl-semibold": "_font-heading-xl-semibold_6v6n8_140",
	typography: "_typography_6v6n8_153"
};
//#endregion
export { Typography_module_default as default };

//# sourceMappingURL=Typography.module.js.map